<template>
  <span class="approve-status-tag" :class="statusClass">
    <span class="tag-text">{{ displayLabel }}</span>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'

const STATUS_CONFIG = {
  Start:      { icon: 'play-circle',  cls: 'status-start'      },
  Processing: { icon: 'sync',         cls: 'status-processing' },
  End:        { icon: 'check-circle', cls: 'status-end'        },
  Create:     { icon: 'play-circle',  cls: 'status-start'      },
  Audit:      { icon: 'sync',         cls: 'status-processing' },
  Pass:       { icon: 'check-circle', cls: 'status-end'        },
  Cancel:     { icon: 'stop',         cls: 'status-cancel'     }
}

const DEFAULT_CONFIG = {
  icon: 'question-circle',
  cls: 'status-unknown'
}

export default {
  name: 'ApproveStatusTag',
  props: {
    status: {
      type: String,
      default: ''
    },
    // 字典 key，默认审批状态，也可由父组件覆盖
    dictKey: {
      type: String,
      default: 'cosys.approveStatus'
    },
    defaultLabel: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters('setting', ['findDataDict']),
    statusConfig() {
      return STATUS_CONFIG[this.status] || DEFAULT_CONFIG
    },
    statusClass() {
      return (STATUS_CONFIG[this.status] || DEFAULT_CONFIG).cls
    },
    displayLabel() {
      if (!this.status) return this.defaultLabel || this.status
      return this.getDictName(this.dictKey, this.status)
    }
  },
  methods: {
    getDictName(dictKey, value) {
      if (!value) return value
      const list = this.findDataDict(dictKey)
      if (!list) return value
      const item = list.find(i => i.value === value)
      return item ? item.name : value
    }
  }
}
</script>

<style scoped>
.approve-status-tag {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px 3px 8px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.3px;
  white-space: nowrap;
  border: 1px solid transparent;
  transition: all 0.2s;
}

.tag-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

.tag-icon {
  font-size: 12px;
  line-height: 1;
}

/* 已开始 - 蓝色 */
.status-start {
  background: linear-gradient(135deg, #e6f7ff 0%, #d0eeff 100%);
  color: #096dd9;
  border-color: #91d5ff;
}
.status-start .tag-dot {
  background-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

/* 审核中 - 橙黄色，带动画 */
.status-processing {
  background: linear-gradient(135deg, #fff7e6 0%, #ffefd0 100%);
  color: #d46b08;
  border-color: #ffd591;
}
.status-processing .tag-dot {
  background-color: #fa8c16;
  box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2);
  animation: pulse-orange 1.5s infinite;
}
.status-processing .tag-icon {
  animation: spin 2s linear infinite;
}

/* 已结束 - 绿色 */
.status-end {
  background: linear-gradient(135deg, #f0fff4 0%, #d9f7e8 100%);
  color: #389e0d;
  border-color: #95de64;
}
.status-end .tag-dot {
  background-color: #52c41a;
  box-shadow: 0 0 0 2px rgba(82, 196, 26, 0.2);
}

/* 已终止 - 红色 */
.status-cancel {
  background: linear-gradient(135deg, #fff1f0 0%, #ffd9d9 100%);
  color: #cf1322;
  border-color: #ffa39e;
}
.status-cancel .tag-dot {
  background-color: #ff4d4f;
  box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
}

/* 未知状态 */
.status-unknown {
  background: #fafafa;
  color: #595959;
  border-color: #d9d9d9;
}
.status-unknown .tag-dot {
  background-color: #8c8c8c;
}

/* 动画 */
@keyframes pulse-orange {
  0%, 100% { box-shadow: 0 0 0 2px rgba(250, 140, 22, 0.2); }
  50%       { box-shadow: 0 0 0 4px rgba(250, 140, 22, 0.35); }
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}
</style>
